export default __webpack_public_path__ + "static/UD-vert-c05a2ec07c9faea688826ad25d272d18.svg";